/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './RadioInput.scss'
import React from 'react'
import RadioGroupContext from './RadioGroupContext'

function RadioInput(props) {
  const idName = props.id || ''
  const className = props.className || ''
  const onChange = props.onChange || (() => {})
  const value = props.value || ''

  const handleClick = (e, name) => {
    const dummyEvent = { target: { name: name, value: props.value } }
    onChange(dummyEvent)
  }

  return (
    <RadioGroupContext.Consumer>
      {({ name, nameUniqueValue, inputValue }) => (
        <input
          className={`RadioInput ${className}`}
          type="radio"
          id={idName}
          name={nameUniqueValue}
          value={value}
          checked={value && inputValue && `${value}` === `${inputValue}`}
          onClick={e => handleClick(e, name)}
          onChange={() => {}}
        />
      )}
      {/*onChangeは不要だが警告がでるので空のメソッドを定義する*/}
    </RadioGroupContext.Consumer>
  )
}

export default RadioInput
